<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/horimetroKM"> Horímetro KM </router-link>
    </div>
    <tab-navegacao-controle-frota />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="3">
            <v-select
              v-model="equipamentoSelected"
              :items="findEquipamentoAtivo"
              label="Prefixo"
              item-text="prefixo"
              item-value="id"
              persistent-hint
              return-object
              single-line
              :counter="15"
              :rules="[(v) => !!v || 'O prefixo é obrigatório']"
              required
            >
            </v-select>
          </v-col>
          <v-col col="3">
            <v-select
              v-model="equipamentoSelected"
              :items="findEquipamentoAtivo"
              label="Apelido"
              item-text="apelido"
              item-value="id"
              persistent-hint
              return-object
              single-line
              :rules="[(v) => !!v || 'O apelido é obrigatório']"
              required
            >
            </v-select>
          </v-col>
          <v-col cols="3" sm="3">
            <v-text-field
              label="HR KM"
              v-model="hr_KM"
              :counter="10"
              :rules="[(v) => !!v || 'O HR KM é obrigatório']"
              v-bind:options="options"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="3" sm="3">
                    <v-menu
                      v-model="data1"
                      :close-on-content-click="false"
                      max-width="290"
                    ><template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDate1"
                          clearable
                          label="Data HR"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="data_HR = null"
                          required
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="data_HR"
                        @change="data1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col
                  >
        </v-row>
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addHorimetro()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-card>
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items="horimetroKMsLocal"
          :loading="loading"
          loading-text="Buscando dados..."
        >
          <template v-slot:item.ativo="{ item }">
            <v-checkbox
              v-model="item.ativo"
              :label="item.ativo === true ? 'Ativo' : 'Inativo'"
            ></v-checkbox>
          </template>
          <template v-slot:item.dataLancamento="{ item }">
            {{ computedDate(item.dataLancamento) }}
          </template>
          <template v-slot:item.data_HR="{ item }">
            {{ computedDate(item.data_HR) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  @click="removeHorimetro(item.id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-close-thick
                </v-icon>
              </template>
              <span>Remover</span> </v-tooltip
            ><v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="info"
                  @click="editar(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoControleFrota from "../../Tabs/TabControleFrota";
import { enviarHorimetroKMAsync } from "../../../services/horimetroKMService";
import { downloadLista } from "../../../services/horimetroKMService";
import { getUserRoles } from "@/services/loginService";
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "criarHorimetroKM",
  data: () => ({
    overlay: false,
    valid: true,
    showModal: false,
    prefixo: null,
    prefixoEdit: null,
    apelido: null,
    apelidoEdit: null,
    id: null,    
    idEdit: null,
    dataLancamento: null,
    dataLancamentoEdit: null,
    idEquipamento: null,
    idEquipamentoEdit: null,
    data_HR: null,
    data_HREdit: null,
    ativo: false,
    ativoEdit: false,
    data1: false,
    hr_KM: null,
    hr_KMEdit: null,
    equipamentoSelected: null,
    horimetroKMsLocal: [],
    headers: [
      { text: "Id", value: "id" },
      { text: "Data Lançamento", value: "dataLancamento" },
      { text: "Prefixo", value: "prefixo" },
      { text: "Apelido", value: "apelido" },
      { text: "HR KM", value: "hr_KM" },
      { text: "Data HR", value: "data_HR" },
      { text: "Ativo", value: "ativo" },
      { text: "", value: "actions" },
    ],
    options: {
      locale: "pt-BR",
      prefix: "R$",
      precision: 2,
    },
  }),
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("horimetroKM", ["horimetroKMs"]),
    computedDate1() 
    {
      return this.data_HR ? moment(this.data_HR).format("DD/MM/YYYY") : null;
    },
    computedDate2()
    {
      return this.dataLancamento ? moment(this.dataLancamento).format("DD/MM/YYYY") : null;
    },
    findEquipamentoAtivo() {
      return this.equipamentos.filter((m) => {
        return m.ativo === true;
      });
    },
    filteredList() {
      if (this.ativo === false) {
        return this.horimetroKMS.filter((f) => { return (f.ativo === true);
        });
      } else {
        return this.horimetroKMS;
      }
    },
    filteredListEquipamentos() {
      if (this.ativo === false) {
        return this.equipamentos.filter((f) => { return (f.ativo === true);
        });
      } else {
        return this.equipamentos;
      }
    },
  },
  methods: {
    ...mapActions("horimetroKM", ["atualizarHorimetroKMs","atualizarHorimetroKM"]),
    ...mapActions("equipamento", ["atualizarEquipamentos","atualizarEquipamento"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarHorimetroKMAsync(this.prefixo, this.apelido, this.hr_KM, this.data_HR, this.dataLancamento);
        if (resposta) 
        {
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação de cadastro!", "error");
        } 
        else 
        {
          this.overlay = false;
          this.$router.push("/horimetroKM");
        }
      }
    },  
    editar(horimetroKM) {
      this.atualizarHorimetroKM(horimetroKM);
      if (this.isAllowed(3)) {
        this.$router.push(`/horimetroKM/editar`);
      } else {
        this.$router.push(`/horimetroKM/ver`);
      }
    },
    baixarlista() {
      downloadLista();
    },
    computedDate(data) {
      return data ? moment(data).format("DD/MM/YYYY") : null;
    },
    addHorimetro: function (e) {
      if (!this.$refs.form.validate()) {
        e.preventDefault();
      }
      var horimetroKM = new Object();

      horimetroKM.id = null;
      horimetroKM.prefixo = this.prefixo;
      horimetroKM.prefixoEdit = this.prefixoEdit;
      horimetroKM.apelido = this.apelido;
      horimetroKM.apelidoEdit = this.apelidoEdit;
      horimetroKM.dataLancamento = this.dataLancamento;      
      horimetroKM.dataLancamentoEdit = this.dataLancamentoEdit;
      horimetroKM.data_HR = this.data_HR;
      horimetroKM.data_HREdit = this.data_HREdit;
      horimetroKM.hr_KM = this.hr_KM;
      horimetroKM.hr_KMEdit = this.hr_KMEdit;
      horimetroKM.ativo = this.ativo;
      horimetroKM.ativoEdit = this.ativoEdit;
      horimetroKM.idEquipamentoEdit = this.idEquipamentoEdit;

      horimetroKM.id = this.horimetroKMsLocal.length === 0 ? 0 : this.horimetroKMsLocal[this.horimetroKMsLocal.length - 1].id + 1;

      this.horimetroKMsLocal.push(JSON.parse(JSON.stringify(horimetroKM)));
      this.prefixo = null;
      this.prefixoEdit = null;
      this.id = null;
      this.apelido = null;
      this.apelidoEdit = null;
      this.dataLancamento = null;
      this.dataLancamentoEdit = null;
      this.data_HR = null;
      this.data_HREdit = null;
      this.hr_KM = null;
      this.hr_KMEdit = null;
      this.ativo = false;
      this.ativoEdit = false;
      this.idEquipamentoEdit = null;
    },
    /*editaHorimetro(id) {
      this.idEdit = id;
      var horimetroKM = this.horimetroKMsLocal.filter((e) => e.id === this.idEdit);
      this.prefixoEdit = horimetroKM[0].prefixo;
      this.apelidoEdit = horimetroKM[0].apelido;
      this.dataLancamentoEdit = horimetroKM[0].dataLancamento;
      this.data_HREdit = horimetroKM[0].data_HR;
      this.ativoEdit = horimetroKM[0].ativo;
      this.hr_KMEdit = horimetroKM[0].hr_KM;
      this.showModal = true;
    },*/
    removeHorimetro(id) {
      this.horimetroKMsLocal = this.horimetroKMsLocal.filter((e) => e.id != id);
    },
    atualizar: function (e) {
      if (!this.$refs.formEdit.validate()) {
        e.preventDefault();
      }
      this.horimetroKMsLocal[this.idEdit].prefixo = this.prefixoEdit;
      this.horimetroKMsLocal[this.idEdit].apelido = this.apelidoEdit;
      this.horimetroKMsLocal[this.idEdit].data_HR = this.data_HREdit;
      this.horimetroKMsLocal[this.idEdit].dataLancamento = this.dataLancamentoEdit;
      this.horimetroKMsLocal[this.idEdit].hr_KM = this.hr_KMEdit;
      this.horimetroKMsLocal[this.idEdit].ativo = this.ativoEdit;
      this.horimetroKMsLocal[this.idEdit].idEquipamento = this.idEquipamentoEdit;
      this.showModal = false;
      this.prefixoEdit = null;
      this.apelidoEdit = null;
      this.idEdit = null;
      this.data_HREdit = null;
      this.dataLancamentoEdit = null;
      this.hr_KMEdit = null;
      this.idEquipamentoEdit = null;
      this.ativoEdit = false;
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarHorimetroKMs();
      this.horimetroKMsLocal = this.horimetroKMs.slice(0);
      for (var i = 0; i < this.horimetroKMsLocal.length; i++) {
        /*this.$alert(this.horimetroKMsLocal[i].hr_KM, this.horimetroKMsLocal[i].hr_KM, "error");*/
        this.horimetroKMsLocal[i].id = i;
      }
      this.loading = false;
    },
    async obterListaEquipamentos() {
      this.loading = true;
      await this.atualizarEquipamentos();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  created: function () {
    this.obterListaEquipamentos();
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoControleFrota,
  },
};
</script>
